import { useMemo, useState } from 'react'
import { getYoutubeVideoId } from '#app/shared/lib/misc.js'
import { CarouselWithPreview } from './CarouselWithPreview.tsx'
import { FullScreenGallery } from './FullScreenGallery.tsx'

export type GalleryMediaItem =
  | { type: 'image'; url: string }
  | { type: 'video'; url: string; previewImageUrl?: string | null }

export const StickyFullHeightGallery = ({
  imagesArray,
  videoUrl = null,
  videoPreviewImageUrl = null,
  isReserved = false,
  isSold = false,
}: {
  imagesArray: string[]
  videoUrl?: string | null
  videoPreviewImageUrl?: string | null
  isReserved?: boolean
  isSold?: boolean
}) => {
  const [open, setOpen] = useState(false)
  const [activeIndex, setActiveIndex] = useState(0)

  const mediaItems = useMemo((): GalleryMediaItem[] => {
    const hasVideo =
      videoUrl && typeof videoUrl === 'string' && getYoutubeVideoId(videoUrl)
    if (hasVideo) {
      return [
        { type: 'video', url: videoUrl, previewImageUrl: videoPreviewImageUrl },
        ...imagesArray.map((url) => ({ type: 'image' as const, url })),
      ]
    }
    return imagesArray.map((url) => ({ type: 'image' as const, url }))
  }, [imagesArray, videoPreviewImageUrl, videoUrl])

  return (
    <div
      className={`
        w-full max-w-screen z-[1] px-4

        lg:max-w-[888px] lg:px-0

        md:px-7
      `}
    >
      <div className="sticky top-[76px]">
        <CarouselWithPreview
          onClickImage={(index) => {
            setActiveIndex(index)
            setOpen(true)
          }}
          mediaItems={mediaItems}
          isReserved={isReserved}
          isSold={isSold}
        />
      </div>
      <FullScreenGallery
        open={open}
        onClose={() => setOpen(false)}
        mediaItems={mediaItems}
        initialIndex={activeIndex}
      />
    </div>
  )
}
